const defaultStateSubrequest = {
    data: null,
    loading: false,
    error: null,
    loaded: false,
};

const defaultState = {
    data: [],
    extra: [],
    sortedData: [],
    ids: [],
    loading: false,
    error: null,
    loaded: false, //se podria calcular de timestamp diferente a null
    timestamp: null,
    meta: {
        current: 1,
        pageSize: 10,
        total: 0,
    },
    subrequest: defaultStateSubrequest,
};

const entity = (section) => (state = defaultState, action) => {
    switch (action.type) {
        case `${section}_ELEMENT_UPDATE_V2`: {
            const retExtra = action.data?.extra;
            const newExtra = {};

            const checkExist = (list, id) => list.some((e) => e.id === id);
            const getElem = (list, id) => list.find((e) => e.id === id);

            for (const [key, value] of Object.entries(state.extra)) {
                if (retExtra.hasOwnProperty(key)) {
                    const temp = value.map((e) => (checkExist(retExtra[key], e.id) ? getElem(retExtra[key], e.id) : e));
                    newExtra[key] = temp;
                } else {
                    newExtra[key] = value;
                }
            }
            return {
                ...state,
                data: { ...state.data, [action.data?.entity?.id]: action.data?.entity },
                sortedData: state.sortedData.map((e) => (e.id === action.data?.entity.id ? action.data.entity : e)),
                extra: { ...newExtra },
                subrequest: defaultStateSubrequest,
            };
        }

        case `${section}_ELEMENT_UPDATE`: {
            return {
                ...state,
                data: { ...state.data, [action.data.id]: action.data },
                sortedData: state.sortedData.map((e) => (e.id === action.data.id ? action.data : e)),
                subrequest: defaultStateSubrequest,
            };
        }
        case `${section}_ELEMENT_REMOVE`: {
            const { [action.id]: removed, ...rest } = state.data;
            return {
                ...state,
                data: rest,
                sortedData: state.sortedData.filter((e) => e.id !== action.id),
                subrequest: defaultStateSubrequest,
            };
        }
        case `${section}_SUCCESS`: {
            return {
                ...state,
                sortedData: action.data.list,
                data: action.data.list.reduce((acc, cur) => ({ ...acc, [cur.id]: cur }), {}),
                extra: action.data?.extra,
                ids: action.data.list.map((v) => v.id),
                error: null,
                loading: false,
                loaded: true,
                timestamp: Date.now(),
                meta: {
                    current: action.data?.pagination?.current,
                    pageSize: action.data?.pagination?.pageSize,
                    total: action.data?.pagination?.total,
                },
                subrequest: defaultStateSubrequest,
            };
        }
        case `${section}_LOADING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${section}_ERROR`: {
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        }

        case `${section}_RESET`: {
            return defaultState;
        }

        case `${section}_SECONDARY_REQUEST_SUCCESS`: {
            return {
                ...state,
                subrequest: {
                    success: true,
                    loading: false,
                    error: null,
                    data: action.data,
                },
            };
        }
        case `${section}_SECONDARY_REQUEST_LOADING`: {
            return {
                ...state,
                subrequest: {
                    ...state.subrequest,
                    error: null,
                    loading: true,
                    success: false,
                },
            };
        }
        case `${section}_SECONDARY_REQUEST_ERROR`: {
            return {
                ...state,
                subrequest: {
                    ...state.subrequest,
                    error: action.error,
                    loading: false,
                    success: false,
                },
            };
        }
        case `${section}_SECONDARY_REQUEST_RESET`: {
            return {
                ...state,
                subrequest: defaultStateSubrequest,
            };
        }

        case "CONFIG_SESSION_RESET": {
            return defaultState;
        }
        default: {
            return state;
        }
    }
};

export default entity;
